import React from 'react';
import classes from './header-footer.scss';

const Footer = () => {
  return <footer>&copy;2021 Taichi Murakami All rights reserved.</footer>
}

export default Footer;